/*------------------------------------*\
    STEP FORM
\*------------------------------------*/

WW.stepForm = function($) {
    'use strict';

    const forms = {},
        validator = WW.formValidator(),


    /*
        Uses form validator to set error
        states for inputs and returns if
        errors occured or not as a bool.
    */
    validate = (id) => {
        const form = forms[id];
        let passed = true;

        form.steps[form.stepIndex].input.each(function() {
            const value = $(this).val();
            if (validator.validate('empty', value) || !validator.validate(this.id, value)) { // If validation fails add red borders
                $(this).addClass('u-border--red');
                passed = false;
            } else {
                $(this).removeClass('u-border--red'); // If validation succeeds remove red borders
            }
        });
        return passed;
    },


    /*
        Moves to next form step if
        validation is successfull
    */
    move = (id, direction) => {
        const form = forms[id];

        if (direction === 1 && !validate(id)) { // If direction is forward and validation fails
            return;
        }

    	form.steps[form.stepIndex].el.removeClass('is-active');
    	form.stepIndex += direction;
		form.steps[form.stepIndex].el.addClass('is-active');

       	$('html, body').animate({
            scrollTop: form.el.offset().top + form.el.data('scroll-offset')
        }, 1000);
    },


    /*
        Prev and next sets direction for
        movement between steps.
    */
    prev = (e) => {
    	e.preventDefault();
    	move($(e.target).closest('.js-step-form').attr('id'), -1);
    },

    next = (e) => {
    	e.preventDefault();
        move($(e.target).closest('.js-step-form').attr('id'), 1);
    },


    /*
        Init caches all formes and their inputs.
        Also adds event listeners to prev/next.
    */
    init = () => {
        $('.js-step-form').each(function() {
            const id = this.id,
                that = $(this);

            forms[id] = {
                el: that,
                stepIndex: 0,
                steps: []
            };

            $(this).find('.js-step-form__step').each(function() {
                const that = $(this);
            	forms[id].steps.push({
                    el: that,
                    input: that.find('input')
                });
            });

            that.find('.js-step-form__next').on('click', next);
            that.find('.js-step-form__prev').on('click', prev);
        });
    };

    init();
    return this;
};

// .stepForm($)